import api from './client'

// Backend-proxied geocoding (meters-to-web-mobile-2026-09-27-geo-and-bbox-
// contract.md): cache -> our own Nominatim -> Google fallback. Replaces the
// old client-side Google Geocoding call so the Google key never ships in
// the web bundle.
export interface GeoResult {
  lat:       number
  lng:       number
  display:   string | null
  // 'street'/'settlement' means the pin is a street or town centroid, not
  // the actual address -- worth showing differently, not just as a pin.
  precision: 'house' | 'street' | 'settlement' | 'unknown'
  // Attribution ("© OpenStreetMap contributors") is a licence obligation
  // when this is 'nominatim', not a style choice -- show it whenever this
  // value reaches that source. 'google' needs none.
  source:    'nominatim' | 'google'
}

export const geoApi = {
  geocode: (address: string) => api.get<GeoResult>('/geo/geocode', { params: { address } }),
  reverse: (lat: number, lng: number) => api.get<GeoResult>('/geo/reverse', { params: { lat, lng } }),
}
